
import React from 'react';
import { Send, PaperclipIcon, Loader2 } from 'lucide-react';

interface ChatInputProps {
  inputMessage: string;
  setInputMessage: (message: string) => void;
  handleSendMessage: () => void;
  triggerFileInput: () => void;
  isUploading: boolean;
  onPromptClick: (prompt: string) => void;
  showSuggestions?: boolean;
}

const ChatInput = ({
  inputMessage,
  setInputMessage,
  handleSendMessage,
  triggerFileInput,
  isUploading,
  onPromptClick,
  showSuggestions = true
}: ChatInputProps) => {
  return (
    <div className="space-y-4">
      <div className="relative">
        <input 
          type="text" 
          value={inputMessage} 
          onChange={e => setInputMessage(e.target.value)} 
          onKeyDown={e => e.key === 'Enter' && handleSendMessage()} 
          placeholder="Tell us about your business..." 
          className="w-full bg-deepshadow/50 border border-goldcore/20 rounded-full py-3 px-4 pr-24 text-softwhite focus:outline-none focus:ring-2 focus:ring-goldcore/50" 
        />

        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center gap-2">
          <button 
            onClick={triggerFileInput} 
            disabled={isUploading} 
            className="h-8 w-8 rounded-full bg-deepshadow/70 text-goldcore flex items-center justify-center hover:bg-deepshadow"
          >
            {isUploading ? <Loader2 size={16} className="animate-spin" /> : <PaperclipIcon size={16} />}
          </button>

          <button 
            onClick={handleSendMessage} 
            className="h-8 w-8 rounded-full bg-goldcore text-knightblack flex items-center justify-center"
          >
            <Send size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;
